import * as actions from './actions'
import { redirectOnSave, saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set, equals, when } from 'cerebral/factories'
import { moduleState, props, state } from 'cerebral'

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.clearList,
  actions.find,
  actions.setList,
  saveEntities(),
]

export const findHolidays = [
  //
  actions.findHolidays,
]

export const fetchDiningRdMenus = [
  //
  actions.fetchDiningRdMenus,
]

export const fetchMenuEventsForDate = [
  //
  actions.fetchMenuEventsForDate,
]

export const getDiningRdMenuMeals = [
  //
  actions.getDiningRdMenuMeals,
]

export const parseMenuDocx = [
  //
  actions.parseMenuDocx,
]

export const findThemes = [
  //
  actions.findThemes,
]

export const findForCalendar = [
  when(state`route.path`, (path) => path.includes('publication')),
  {
    true: [set(props`useRouteParams`, false)],
    false: [set(props`useRouteParams`, true)],
  },
  actions.find,
  saveEntities(),
  actions.mapCalendarFields,
]

export const selectCalendarTheme = [
  //
  actions.selectCalendarTheme,
]

export const setPaperSizeName = [
  when(moduleState`calendarPrint.paperSizeName`, props`value`, (currentPaperSize, nextPaperSize) => currentPaperSize !== nextPaperSize),
  {
    true: [
      //
      actions.applyPaperSizeDefaults,
      actions.setPaperSizeName,
    ],
    false: [],
  },
]

export const setFontSizeName = [
  //
  actions.setFontSizeName,
]

export const setPaperOrientation = [
  //
  actions.setPaperOrientation,
]

export const setPrintSingleLine = [
  //
  actions.setPrintSingleLine,
]

export const setHideEventDescription = [
  //
  actions.setHideEventDescription,
]

export const setEventTypeHidden = [
  //
  actions.setEventTypeHidden,
]

export const setEventLocationHidden = [
  //
  actions.setEventLocationHidden,
]

export const setEventCalendars = [
  //
  actions.setEventCalendars,
]

export const setWeeklyCalendarLayout = [
  //
  actions.setWeeklyCalendarLayout,
]

export const setBirthdaysShown = [
  //
  actions.setBirthdaysShown,
]

export const setDayPrintInterval = [
  //
  actions.setDayPrintInterval,
]
export const setLevelsOfCare = [
  //
  actions.setLevelsOfCare,
]

export const setTransportRequiredOnly = [
  //
  actions.setTransportRequiredOnly,
]

export const setEndTimeHidden = [
  //
  actions.setEndTimeHidden,
]

export const setExpandToFillPage = [
  //
  actions.setExpandToFillPage,
]

export const setIncludeMenu = [
  //
  actions.setIncludeMenu,
]

export const getBirthdays = [
  //
  actions.getBirthdays,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const create = [
  actions.create,
  saveEntities(),
  showFeedback({ title: `Import completed successfully`, type: 'success' }), // This message will not be appropriate if create is used for other purposes.
]

export const resetUploadState = [
  //
  actions.resetUploadState,
]

export const setUploadErrorMessage = [
  //
  actions.setUploadErrorMessage,
]

const successFeedback = (actionCompleted) => [
  equals(props`values.eventType`),
  {
    Event: showFeedback({ title: `Event ${actionCompleted}`, type: 'success' }),
    Menu: showFeedback({ title: `Meal ${actionCompleted}`, type: 'success' }),
  },
]

export const redirectToList = [
  when(state`events.lastListView`),
  {
    true: [
      //
      set(props`path`, state`events.lastListView`),
      route.toPath,
    ],
    false: [
      equals(props`values.eventType`),
      {
        Event: route.toEventCalendar,
        Menu: route.toMealsCalendar,
      },
    ],
  },
]

export const save = [
  //
  actions.save,
  saveEntities(),
  successFeedback('saved'),
  when(state`route.params.stayOnRoute`),
  {
    true: [
      //
    ],
    false: [
      //
      redirectToList,
    ],
  },
]

export const changeEventTime = [
  //
  actions.changeEventTime,
  successFeedback('changed'),
]

export const remove = [
  //
  actions.remove,
  successFeedback('deleted'),
  findForList,
]

export const togglePublished = [
  //
  actions.togglePublished,
  saveEntities(),
]

export const setEditRangeVisible = [
  //
  actions.setEditRangeVisible,
]

export const setCalendarState = [
  //
  actions.setCalendarState,
]

export const saveWithoutFeedback = [
  //
  actions.save,
  actions.saveImage,
  saveEntities(),
  when(state`route.path`, redirectOnSave),
  {
    true: [
      ({ props: { entities } }) => {
        const [result] = entities.events
        // Redirect back to appropriate event.
        return { params: { id: result?._id } }
      },
      route.toEvent,
    ],
    false: [],
  },
]

export const setSaveAction = [
  //
  actions.setSaveAction,
]
